import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.close,
    classes: "login-modal"
  }, {
    content: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal__title" }, "Log in or Create a free account", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal__description" }, "Please log in or create a free account to continue", -1)),
      _createElementVNode("div", { class: "modal-controls" }, [
        _createElementVNode("button", {
          class: "button medium",
          onClick: $setup.onLogin
        }, "Log in"),
        _createElementVNode("button", {
          class: "button primary medium",
          onClick: $setup.onCreate
        }, "Create account")
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}